import campaignsReducer from './localizations.slice'

export default campaignsReducer
